var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 31 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2h8v14h-8z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9c0-3 1-5 3-7a9 9 0 00-5-2C5 0 1 4 1 9s4 9 9 9a9 9 0 005-2 9 9 0 01-3-7z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 9c0 5-4 9-9 9a9 9 0 01-6-2 9 9 0 004-7c0-3-1-5-4-7a9 9 0 016-2c5 0 9 4 9 9z",
    fill: "#F79E1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.a6d3856c7839f8be1b25f00ae45f1d0f.svg";
export { ForwardRef as ReactComponent };